import { Component } from '@poa/core';
import { action, observable, Observer } from '@poa/state';
import React from 'react';
import DataTable from '../components/data-table/data-table';
import Navbar from '../components/navbar';
import RouteLoading from '../components/route-loading';
import TableFilter from '../components/table-filter';
import { PayerModal } from '../components/payer-modal/add-payer-modal';

class PayersPage extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa

  localState = observable({
    isModalOpened: false,
    selectedPayerId: null,
    lastSearch: null,
    currentPage: 1,
    page_size: 25
  });

  lastSorting = new Map([['total', 'desc']]);

  saveColumnPreset = async preset => {
    await this.actions.payersActions.saveColumnPreset(preset);
  };

  componentDidMount() {
    const { startDate, endDate } = this.store.payers.filters;
    this.actions.payersActions.fetchPayers(        
      this.store.payers.filters.filtering.selected.label === 'all' ? null : this.store.payers.filters.filtering.selected.label,
      1,
      null,
      25,
      startDate.toISOString(),
      endDate.toISOString(),
      );
  }

  onFilterChange = async (filterChoice) => {
    console.log('filterChoice', filterChoice);
    this.store.payers.filters.filtering.selected = filterChoice;
  };

  onSearchChange = async searchString => {
    if (searchString.target) {
      this.localState.lastSearch = searchString.target.value;
    } else {
      this.localState.lastSearch = '';
    }
  };

  onSearchClick = () => {
    this.actions.payersActions.fetchPayers(        
      this.store.payers.filters.filtering.selected.label === 'all' ? null : this.store.payers.filters.filtering.selected.label,
      1,
      this.localState.lastSearch,
      this.localState.page_size,
    )
  };

  onPageChange = async page => {
    const { startDate, endDate } = this.store.payers.filters;
    this.localState.currentPage = page;
    await this.actions.payersActions.refreshPayers(
      this.store.payers.filters.filtering.selected.label === 'all' ? null : this.store.payers.filters.filtering.selected.label,
      page,
      this.lastSearch,
      this.localState.page_size,
      startDate.toISOString(),
      endDate.toISOString(),
    );
  };

  onEditClick = async payer_id => {
    const { data } = await this.env.http.get(`/payer/${payer_id}/`);

    await this.env.modal({
      html: (
        <PayerModal
          manageMode="edit"
          onSave={this.onEditNewPayer}
          payerId={data.payer_id}
        />
      )
    });
  };

  onModalClose = () => {
    this.localState.isModalOpened = false;
  };

  onModalOpen = action(payerId => {
    this.localState.selectedPayerId = payerId;
    this.localState.isModalOpened = true;
  });

  onEditNewTranfer = ({ from, to, date, type, accountId, transferId }) => {
    this.env.http.post(`${type}/transfer/`, {
      account_id: accountId,
      from,
      to,
      transfer_date: date,
      transfer_id: transferId
    });

    this.actions.transfersActions.refreshPayers(
      this.lastFilters,
      this.lastPage,
      this.lastSorting,
      this.lastSearch
    );

    this.env.alert.clickConfirm();
  };

  SearchField = () => {
    return (
    <div style={{ verticalAlign: 'middle', width: '300px' }}>
    <div className='search__input input'>
      <input
        type='text'
        placeholder='поиск'
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            this.onSearchClick();
          }
        }}
        onChange={this.onSearchChange}>
      </input>
      <svg className='icon icon-search' width='15px' height='15px' viewBox='0 0 15 15'
           version='1.1' xmlns='http://www.w3.org/2000/svg'>
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g fillRule='nonzero' fill='#DBDBDB'>
            <path
              d='M14.8163265,13.9346939 L11.2102041,10.3285714 C12.1040816,9.23877551 12.6428571,7.84285714 12.6428571,6.32142857 C12.6428571,2.83163265 9.81122449,0 6.32142857,0 C2.82857143,0 0,2.83163265 0,6.32142857 C0,9.81122449 2.82857143,12.6428571 6.32142857,12.6428571 C7.84285714,12.6428571 9.23571429,12.1071429 10.3255102,11.2132653 L13.9316327,14.8163265 C14.1765306,15.0612245 14.5714286,15.0612245 14.8163265,14.8163265 C15.0612245,14.5744898 15.0612245,14.1765306 14.8163265,13.9346939 Z M6.32142857,11.3846939 C3.52653061,11.3846939 1.25510204,9.11326531 1.25510204,6.32142857 C1.25510204,3.52959184 3.52653061,1.25510204 6.32142857,1.25510204 C9.11326531,1.25510204 11.3877551,3.52959184 11.3877551,6.32142857 C11.3877551,9.11326531 9.11326531,11.3846939 6.32142857,11.3846939 Z'></path>
          </g>
        </g>
      </svg>
    </div>
  </div>
  )}


  render() {
    const { filters, selectors, ui } = this.store.payers;
    const {
      setDates,
      changeGrouping,
      changeRounding,
    } = this.actions.payersActions;

    return (
      <RouteLoading meta={this.store.payers.meta}>
        <div className="content">
          <Navbar />

          <TableFilter
            state={filters}
            selectors={selectors}
            onDatesChange={setDates}
            onGroupingChange={changeGrouping}
            onIsFractionalChange={changeRounding}
            withoutFractionalChange
            withoutStatusChange
            withoutGroupingChange
            withoutFilteringChange={false}
            withSearch={false}
            withCustomSearch={true}
            withColumnsConfigure={false}
            getTableNode={() => this.node}
            onFilteringChange={this.onFilterChange}
            render={() => (
              <div key={''} style={{ display: 'flex' }}>
              {this.SearchField()}

              <div style={{ verticalAlign: 'middle' }}>
                <button type='button' className='archive_button' onClick={this.onSearchClick}>
                  ПОИСК
                </button>
              </div>
              </div>
            )}
          />
          
          <div className='container' style={{ margin_bottom: '0' }}>
            <div className='inner'>
              <div className='inner-scroll accounts-table'>
                <Observer>
                  {() =>
                    selectors.filteredData.map((table, idx) => (
                      <DataTable
                        ref={node => (this.node = node)}
                        headerSticky={selectors.filteredData.length > 1 ? false : 50}
                        key={idx}
                        data={table}
                        columnSettings={filters.columnSettings}
                        isDecimalThunk={() => filters.isDecimal}
                        favorites={ui.favorites}
                        initialSortingMap={this.lastSorting}
                        toggleFavorite={this.actions.accountsActions.toggleFavorite}
                        requestModalOpen={this.onModalOpen}
                        isServerSide
                        currentPage={table._meta.page}
                        pageSize={table._meta.page_size}
                        pages={table._meta.pages}
                        onPageChange={this.onPageChange}
                        selectors={selectors}
                        name={'payers'}
                        account_filters={null}
                      />
                    ))
                  }
                </Observer>

                <Observer>
                  {() => (
                    <PayerModal
                      isOpened={this.localState.isModalOpened}
                      requestClose={this.onModalClose}
                      payerId={this.localState.selectedPayerId}
                    />
                  )}
                </Observer>
              </div>
            </div>
          </div>
        </div>
      </RouteLoading>
    );
  }
}

export default Component()(PayersPage);
